import React, { useState } from "react";
import Form from "./Form";
import { postRequest } from "../../../utils/request";
import { apiUrl } from "../../../utils/apiUrl";
import { toast } from "../../../utils/helpers";

const Edit = ({ubicacion, getUbicaciones, toggle}) => {
    const [errors, setErrors] = useState([]);

    const editUbicacion = async (event) => {
        event.preventDefault();

        const data = new FormData(event.target);

        const response = await postRequest(apiUrl(`ubicaciones/${ubicacion.id}`), data);

        if (response.success) {
            getUbicaciones();
            toggle();
        }

        if (response.code === 422) {
            setErrors(response.data.message);
        }
    };
    
    const deleteUbicacion = async (event) => {
        event.preventDefault();
    
        const response = await postRequest(apiUrl(`ubicaciones/${ubicacion.id}`), {}, 'delete');
    
        if (response.success) {
            getUbicaciones();
            toggle();
            toast("Ubicación borrada.");
        } else {
            toast(response.data, "error");
        }
    };

    return <form method='post' onSubmit={editUbicacion}>
        <input type='hidden' name='_method' value='patch' />
        <div className='popup__header'>Editar Ubicación de inventario</div>
        <div className='popup__body'>
            <Form ubicacion={ubicacion} errors={errors} />
        </div>
        <div className='popup__footer'>
            <button
                type='button'
                className='btn float-left'
                onClick={(e) => deleteUbicacion(e)}>
                <i className='fas fa-trash-alt'></i>
            </button>

            <button
                type='button'
                onClick={toggle}
                className='btn btn-plain'>
                Cancelar
            </button>
            <button type='submit' className='btn btn-primary'>
                Guardar
            </button>
        </div>
    </form>;
};

export default Edit;